//
// ReportManager.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./SubserviceManager";
import "./CommentManager";
import "../models/local/Report";
import "./Voucher";
import "./ReportStatus";
import "./MobileBIClientURL";

var ReportManager = createModule("transport::ReportManager", ["transport::SubserviceManager"], EventDispatcher, [
    {
        REPORT_READY: 60107,
        REPORT_CHANGED: 60108,
        REPORT_DELETED: 60110,
        REPORT_UPDATED: 60109,
    },
    ,
    ,
    ,
    {
        _initializeTetheredReport_s: [1,7],
        getShareURL: [7,1],
        _getReport_o: [1,1],
        getReportByContent: [1,7],
        isTethered: [2,1],
        _initializeTetheredReport_o: [1,1],
        _getReport_s: [1,7],
        getThumbnail: [1,1],
        updateAlertSubscriptions: [1,1,[7],[7]],
        setThemeVersion: [0,7],
        deleteReportFromServer: [1,1,1],
        getMobileBIClientURLWithSection: [7,1,7],
        _printReport_oo: [1,1,1],
        _getReportWithUserState_o: [1,1],
        _getReportWithUserState_s: [1,7],
        getCatalogSearchSuggestions: [1,4],
        checkForPrivateDataForAllSubscribedReports: [1],
        lookUpReportsByPath: [1,[7]],
        getReportByContentWithDataLevel: [1,7,4],
        canSaveReportState: [2,1],
        getReportByReposKey: [1,7],
        _getPrivateData_os: [1,1,7],
        _getPrivateData_o: [1,1],
        getSubscriptionProgress: [5,1],
        getAllCatalogSearchSuggestions: [1],
        getNewReportInstanceWithUserState: [1,7,7],
        getThumbnailPath: [7,1],
        getAlertableItems: [1,1],
        _printReport_ooss: [1,1,1,7,7],
        unsubscribeFromAlert: [1,1,7],
        buildUUID: [7,1,1],
        reportOpened: [0,1],
        _printReport_os: [1,1,7],
        _printReport_oos: [1,1,1,7],
        checkForUpdates: [1,[1]],
        getReportStatus: [4,1],
        _printReport_oss: [1,1,7,7],
        getCommentManager: [1,1],
        _getReportMetadata_s: [1,7],
        _getReportMetadata_o: [1,1],
        _printReport_osss: [1,1,7,7,7],
        getReportSubdirectoryPath: [7,1],
        getShareURLWithSection: [7,1,7],
        getMobileBIClientURL: [7,1],
        getNewReportInstance: [1,7,7],
        _printReport_o: [1,1],
        reportClosed: [0,1],
        subscribeToAlert: [1,1,7],
        getReportByContentForClient: [1,7],
        ensureUUID: [0,1,1],
        getReportForLocation: [1,7,2],
    },
    {
        handleDataQuery: [0,1,1],
        isPrintable: [2,1],
        isRemovable: [2,1],
        parseMobileBIClientURL: [1,7],
    },
    ["getReportWithUserState","getReport","initializeTetheredReport","getReportMetadata","printReport","getPrivateData"],
]);
export default ReportManager;
